package com.merkost.handpass.api.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MonetaryAmount(
    @SerialName("minor_units") val minorUnits: Long,
    val currency: String,
)
